let headers = {
    'Content-Type': 'application/json',
    'Accept' :'application/json'
    // 'Accept' : 'text/csv'
};

export const getAuthConfig = function () {
  let headers = {
    'authorization': localStorage.getItem("id_token"),
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'team-id': localStorage.getItem('team_id') || null
  }
  return headers
};

export function post (url, data, version) {
  return new Promise(function (resolve, reject) {
    try {
      if (null === url || undefined === url || '' === url) {
        reject('URL not present.');
      } else {
        const token = localStorage.getItem('id_token');
        if (token) {
          headers.Authorization = token;
          headers['team-id'] = localStorage.getItem('team_id');
        }
        if (version && version !== '') {
          headers.version = version;
        } else {
          delete headers.version;
        }
        const options = {
          method: 'POST',
          headers: getAuthConfig(),
          body: JSON.stringify(data)
        };
        fetch(url, options)
          .then(res => {
            if(res.status && res.status === 401) {
              return resolve(res)
            }
            return res.status !== 204 && res.json()
          })
          .then(res => {
            resolve(res);
          })
          .catch(error => {
            console.error("[Fetch call :: ERROR]",error);            
            reject(error)
          });
      }
    } catch (error) {
      reject(error);
    }
  });
}


export async function get (url) {
    return new Promise(function (resolve, reject) {
      try {
        if (null === url || undefined === url || '' === url) {
          reject('URL not present.');
        } else {
          const token = localStorage.getItem('id_token');
          if (token) {
            headers.Authorization = token;
            headers['team-id'] = localStorage.getItem('team_id');
          }
          const options = {
            method: 'GET',
            headers: getAuthConfig()
          };
          fetch(url, options)
            .then(res => {
              if(res && res.status && res.status === 401) {
                return resolve(res)
              }
              return res.status !== 204 &&res.json()
            })
            .then(res => {
              resolve(res);
            })
            .catch(error => reject(error));
        }
      } catch (error) {
        reject(error)
      }
    });
  }

  export function put (url, data) {
    return new Promise(function (resolve, reject) {
      try {
        if (null === url || undefined === url || '' === url) {
          reject('URL not present.');
        } else {
          const token = localStorage.getItem('id_token');
          if (token) {
            headers.Authorization = token;
            headers['team-id'] = localStorage.getItem('team_id');
          }
          const options = {
            method: 'PUT',
            headers: getAuthConfig(),
            body: JSON.stringify(data)
          };
          fetch(url, options)
            .then(res => {
              return res.json()
            })
            .then(res => {
              resolve(res);
            })
            .catch(error => {
              console.error("[Fetch call :: ERROR]",error);            
              reject(error)
            });
        }
      } catch (error) {
        reject(error);
      }
    });
  }

  export function del (url) {
    return new Promise(function (resolve, reject) {
      try {
        if (null === url || undefined === url || '' === url) {
          reject('URL not present.');
        } else {
          const token = localStorage.getItem('id_token');
          if (token) {
            headers.Authorization = token;
            headers['team-id'] = localStorage.getItem('team_id');
          }
          const options = {
            method: 'DELETE',
            headers: getAuthConfig(),
            // body: JSON.stringify(data)
          };
          fetch(url, options)
            .then(res => {
              return res.json()
            })
            .then(res => {
              resolve(res);
            })
            .catch(error => {
              console.error("[Fetch call :: ERROR]",error);            
              reject(error)
            });
        }
      } catch (error) {
        reject(error);
      }
    });
  }

export function postCSV (url, data) {
  return new Promise(function (resolve, reject) {
    try {
      if (null === url || undefined === url || '' === url) {
        reject('URL not present.');
      } else {
        let headers= {
          // 'Content-Type': 'multipart/form-data'
        }
        const token = localStorage.getItem('id_token');
        if (token) {
          headers.Authorization = token;
          headers['team-id'] = localStorage.getItem('team_id');
        }
        const options = {
          method: 'POST',
          headers: getAuthConfig(),
          body:data,
          // body: JSON.stringify(data)
        };
        fetch(url, options)
          .then(res => {
            return res.json()
          })
          .then(res => {
            resolve(res);
          })
          .catch(error => {
            console.error("[Fetch call :: ERROR]",error);            
            reject(error)
          });
      }
    } catch (error) {
      reject(error);
    }
  });
}

export function downloadFile (url, data) {
  return new Promise(function (resolve, reject) {
    try {
      if (null === url || undefined === url || '' === url) {
        reject('URL not present.');
      } else {
        const token = localStorage.getItem('id_token');
        if (token) {
          headers.Authorization = token;
          headers['team-id'] = localStorage.getItem('team_id');
        }
        const options = {
          method: 'POST',
          headers: getAuthConfig(),
          body: JSON.stringify(data)
        };
        fetch(url, options)
          .then(res => {
            return data.type==="csv" ? res.text() : res.json()
          })
          .then(content => {
            resolve(content);
          })
          .catch(error => {
            console.error("[Fetch call :: ERROR]",error);            
            reject(error)
          });
      }
    } catch (error) {
      reject(error);
    }
  });
}

export function getMFAStatus (url) {
  return new Promise(function (resolve, reject) {
    try {
      if (null === url || undefined === url || '' === url) {
        reject('URL not present.');
      } else {
        const options = {
          method: 'GET',
          headers: getAuthConfig()
        };
        fetch(url, options)
          .then(res => res.status !== 204 &&res.json())
          .then(res => {
            resolve(res);
          })
          .catch(error => reject(error));
      }
    } catch (error) {
      reject(error)
    }
  });
}

export async function loginpost (url, data) {
  return new Promise(function (resolve, reject) {
    try {
      if (null === url || undefined === url || '' === url) {
        reject('URL not present.');
      } else {
        const options = {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(data)
        };
        
        fetch(url, options)
          .then(res => {
            return res.status !== 204 && res.json()
          })
          .then(res => {
            resolve(res);
          })
          .catch(error => {
            console.error("[Fetch call :: ERROR]",error);            
            reject(error)
          });
      }
    } catch (error) {
      reject(error);
    }
  });
}
  